<div class="reset-container">
  <p class="text-center"><img src="{{ 'APP.LOGO' | translate }}" width="300" alt="logo"/></p>

  <p class="text-center info">
    {{'forgot_password.title_confirm_password' | translate}}
  </p>

  <form class="confirm-password-form" novalidate (ngSubmit)="onSubmit(user)" [formGroup]="user" >
    <input required formControlName="newPassword"
           name="newPassword"
           type="password"
           class="form-control"
           placeholder="{{'forgot_password.new_password' | translate}}" />

    <input required
           formControlName="confirmPassword"
           name="confirmPassword"
           type="password"
           class="form-control"
           placeholder="{{'register.fields.confirm_password' | translate}}" />
    <button [disabled]="user.invalid"
            type="submit"
            class="btn btn-default confirm-btn">{{'forgot_password.confirm_btn' | translate}}</button>
  </form>

  <p class="message d-flex justify-content-center">
    <span *ngIf="errorMessage" class="error">{{errorMessage}}</span>
  </p>

</div>



// WEBPACK FOOTER //
// ./src/app/auth/confirm-password/confirm-password.component.html